export default __webpack_public_path__ + "static/3-70b607963210ac985d10c5373090e068.webp";